export default "__VITE_ASSET__BHuxb0SQ__"